import { afterLoadIdle } from "./afterLoadIdle";

let bookingChunkPrefetched = false;

export const prefetchBookingChunk = (): void => {
  if (bookingChunkPrefetched) return;
  bookingChunkPrefetched = true;
  afterLoadIdle(() => {
    import("../../routes/bookingInProgress/BookingInProgress");
    // DesktopLandingPage's on-demand panels (booking / itinerary, result detail, stays map).
    import("../../component/reusableComponent/deskTopDestination/deskTopMultipleItineraryDetails/deskTopMultipleItineraryDetails");
    import("../../component/reusableComponent/resultDetailScreen/ResultDetailScreen");
    import("../../component/staysMap/StaysMap");
  });
};
